import { connect } from 'react-redux'
import {
  getCurrentProduct,
  getHasActivePackage,
  getHasEstimatedPrice,
  getHasPackages,
  getIsPackagesPagePath,
  getIsPaymentBannerDisplayable,
  getIsProductPagePath,
  getIsQuoteTOSFeatureEnabled,
  getIsSaleHomePagePath,
  getIsSelectionPagePath,
  getScreenSize
} from 'store/selectors'
import { MapStateToProps } from 'App/Main/Footer/types'
import { State } from 'store/reducers/index.types'

const mapStateToProps = (state: State): MapStateToProps => ({
  hasActivePackage: getHasActivePackage(state),
  hasEstimatedPrice: getHasActivePackage(state) ? getHasEstimatedPrice(state) : false,
  hasPackages: getCurrentProduct(state) && getHasPackages(state),
  isPackagesPage: getIsPackagesPagePath(state),
  isPaymentBannerDisplayable: getIsPaymentBannerDisplayable(state),
  isProductPage: getIsProductPagePath(state),
  isQuoteTOSFeatureEnabled: getIsQuoteTOSFeatureEnabled(state),
  isSaleHomePage: getIsSaleHomePagePath(state),
  isSelectionPage: getIsSelectionPagePath(state),
  screenSize: getScreenSize(state)
})

export default connect(mapStateToProps)
